import { motion } from "framer-motion";

export default function ComingSoon() {
  return (
    <motion.div
      initial={{ opacity: 0, y: -40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="min-h-screen flex items-center justify-center text-center px-4"
    >
      <div>
        <h1 className="text-4xl md:text-5xl font-bold mb-4">
          🚧 STOP ERROR 404
        </h1>
        <p className="text-gray-500 text-lg max-w-xl mx-auto">
          PAGE NOT FOUND 
        </p>
      </div>
    </motion.div>
  );
}
